import { render } from "./DesignerUsers.vue?vue&type=template&id=001460d3"
import script from "./DesignerUsers.vue?vue&type=script&lang=js"
export * from "./DesignerUsers.vue?vue&type=script&lang=js"
script.render = render

export default script